import React from 'react';
import moment from 'moment';

import { FileTile, Text } from 'shell/components';

const files = [
    {
        id: '1',
        created_on: moment().subtract(5, 'minute').valueOf(),
        data: { name: 'Microsoft Analysis.pdf', type: 'application/pdf' },
        owner_account_id: '1',
    },
];

const owners = {
    1: 'Georgina Watson',
};

const FileTileDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>FileTile</Text>
            {files.map((file) => (
                <FileTile
                    key={file.id}
                    file={file}
                    getNameById={(id) => owners[id]}
                    options={[
                        { key: 'download', value: 'Download' },
                        { key: 'delete', value: 'Delete' },
                    ]}
                    onSelect={console.log}
                />
            ))}
        </>
    );
};

export default FileTileDemo;
